import { overviewKey } from '../overviewCard';
import type { OverviewTone } from '../overviewMeta';

/** Testid prefix, icons and copy keys for the cash-runway card. */
export const CASH_RUNWAY = {
    slot: 'cash-runway',
    icon: 'solar:clock-circle-bold-duotone',
    ctaIcon: 'solar:add-circle-bold-duotone',
    keys: {
        title: overviewKey('cashRunway', 'title'),
        question: overviewKey('cashRunway', 'question'),
        days: overviewKey('cashRunway', 'days'),
        deltaDays: overviewKey('cashRunway', 'deltaDays'),
        cash: overviewKey('cashRunway', 'cash'),
        dailyFixedCost: overviewKey('cashRunway', 'dailyFixedCost'),
        scaleAria: overviewKey('cashRunway', 'scaleAria'),
        emptyBody: overviewKey('cashRunway', 'emptyBody'),
        emptyCta: overviewKey('cashRunway', 'emptyCta'),
    },
};

/** The axis under the bar — the same numbers that decide the tone. */
export const RUNWAY_TICKS = ['0', '30', '90', '180+'];

/** One sentence saying what the number means, per band. */
export const RUNWAY_VERDICT_KEY: Record<OverviewTone, string> = {
    danger: overviewKey('cashRunway', 'verdictDanger'),
    warning: overviewKey('cashRunway', 'verdictWarning'),
    success: overviewKey('cashRunway', 'verdictSuccess'),
};
